import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { OAuthModule } from 'angular-oauth2-oidc';

import { ApiKeysService } from './api-keys.service';

@NgModule({
	imports: [HttpClientModule, OAuthModule],
	providers: [ApiKeysService],
})
export class ApiKeysModule {}



// WEBPACK FOOTER //
// ./src/app/shared/services/api-keys/api-keys.module.ts